import dayjs from 'dayjs';
import { Icon, Input } from '@vechaiui/react';
import { PencilIcon, SearchIcon } from '@heroicons/react/outline';
import { createColumnHelper } from '@tanstack/react-table';
import { useLocalization } from '@fluent/react';
import { useQuery } from '@apollo/client';
import { useRef, useState } from 'react';
import { useToggle } from '@react-hookz/web';

import AppContainerLayout from '#/layouts/AppContainerLayout';
import DataTable from '#/components/display/DataTable';
import Dialog from '#/components/controls/Dialog';
import UserDetailsPanel from '#/components/panels/UserDetailsPanel';
import UserFilterPanel, { FilterProps } from '#/components/panels/UserFilterPanel';
import UserStatusIndicator from '#/components/display/UserStatusIndicator';
import { GetLogisticsDocument, Logistics } from '#/__generated__/graphql/graphql';
import { formatAddress } from '#/utils/formatter';
import { getColorByStatus, UserStatus } from '#/utils/user-status';
import { useInfiniteList } from '#/hooks/use-infinite-list';

const AdminLogisticsListPage = () => {
  const { l10n } = useLocalization();
  const { data, fetchMore, loading } = useQuery(GetLogisticsDocument);
  // {variables: { filter: { orderStatuses: statusTypes, keywords: keywords || undefined } },}
  const rootRef = useRef<HTMLDivElement>(null);
  const elementRef = useRef<HTMLDivElement>(null);

  const [isDetailsPanelOpen, toggleDetailsPanelOpen] = useToggle(false);
  const [selectedUser, setSelectedUser] = useState('');

  const filterList: FilterProps[] = [
    { count: 2, label: l10n.getString('all') },
    { count: 2, label: l10n.getString('admin') },
    { count: 2, label: l10n.getString('editor') },
    { count: 2, label: l10n.getString('driver') },
  ];

  const handleEdit = (user: Logistics) => {
    // TODO - Handle Edit User
  };

  const columnHelper = createColumnHelper<Logistics>();

  const columns = [
    columnHelper.accessor('name', {
      header: () => renderCellHeader('name'),
      cell: (info) => renderCellBody(info.getValue()),
    }),
    columnHelper.accessor('address', {
      header: () => renderCellHeader('Company Location'),
      cell: (info) =>
        renderCellBody(
          formatAddress(info.getValue(), {
            exclude: ['addressCountry', 'addressLocality', 'streetAddress', 'postalCode'],
          }),
        ),
    }),
    columnHelper.accessor('dateCreated', {
      header: () => renderCellHeader('Date Joined'),
      cell: (info) => renderCellBody(dayjs(info.getValue()).format('DD-MMM-YYYY').toUpperCase()),
    }),
    // columnHelper.accessor('companyNumber', {
    //   header: () => renderCellHeader('company-number'),
    //   cell: (info) => renderCellBody(info.getValue()),
    // }),
    // columnHelper.accessor('status', {
    //   header: () => renderCellHeader('status'),
    //   cell: (info) => (
    //     <UserStatusIndicator color={getColorByStatus(info.getValue())} text={info.getValue()} />
    //   ),
    // }),
    // columnHelper.accessor('edit', {
    //   header: () => renderCellHeader('edit'),
    //   cell: (info) => renderCellEdit(info.row.original),
    // }),
  ];

  const renderCellHeader = (label: string) => {
    return (
      <div className="text-left m-3 pb-5 uppercase text-neutral-400">{l10n.getString(label)}</div>
    );
  };

  const renderCellBody = (label: string) => {
    return <div className="text-left m-3 text-black hover:cursor-pointer py-3">{label}</div>;
  };

  const renderCellEdit = (user: Logistics) => {
    return (
      <div
        className="m-3"
        onClick={() => {
          handleEdit(user);
        }}
      >
        <Icon as={PencilIcon} label="check" className="w-5 h-5 text-primary-500" />
      </div>
    );
  };

  useInfiniteList(elementRef, rootRef, () => {
    if (!loading && data?.logistics?.pageInfo.hasNextPage) {
      fetchMore({ variables: { cursor: data?.logistics?.pageInfo?.endCursor } });
    }
  });

  return (
    <AppContainerLayout ref={rootRef}>
      <div className="w-full">
        <h1 className="mb-4">{l10n.getString('logistics')}</h1>
        <div className="flex-col  min-h-screen bg-white p-8 rounded-lg space-y-6">
          {/* <div> */}
          {/* <h5 className="text-black">{l10n.getString('client')}</h5> */}
          {/* <div className=" text-gray-400">{l10n.getString('admin-page-subheader')}</div> */}
          {/* </div> */}
          {/* <div className="flex">
            <Input.Group>
              <Input.LeftElement
                className=""
                children={
                  <Icon
                    as={SearchIcon}
                    label="search"
                    className="justify-items-center w-5 h-5 text-gray-300"
                  />
                }
              />
              <Input className="h-11 mr-10 w-96" placeholder={'Search name, email or username'} />
            </Input.Group>
            <UserFilterPanel filterList={filterList} />
          </div> */}

          <div>
            {!!data?.logistics?.edges && data.logistics.edges.length > 0 ? (
              <DataTable
                data={data.logistics.edges.map(({ node }) => node)}
                columns={columns}
                className={'w-full'}
                onClick={(values) => {
                  toggleDetailsPanelOpen(true);
                  setSelectedUser(values.id);
                }}
              />
            ) : (
              <div>No record found</div>
            )}

            <div ref={elementRef} />
          </div>
        </div>
      </div>

      <Dialog
        closeButton={l10n.getString('close')}
        isModal
        isOpen={isDetailsPanelOpen}
        onClose={() => {
          setSelectedUser('');
          toggleDetailsPanelOpen(false);
        }}
        title={`${l10n.getString('account-details')}`}
      >
        <UserDetailsPanel userId={selectedUser} userType="logistic" />
      </Dialog>
    </AppContainerLayout>
  );
};
export default AdminLogisticsListPage;
